<template>
  <v-card max-width="100%" class="mx-auto banner">
    <v-carousel cycle :continuous="false"
      :show-arrows="false"
      hide-delimiter-background
      delimiter-icon="mdi-square"
      height="auto">
      <v-carousel-item v-for="(i) in 5  " :key="i" :transition="fade - transition">

<!-- 
        <div v-if="i == 1">
          <img v-if="this.$i18n.locale == 'es'" src="@/assets/banners/es/1564x726.png" >
          <img v-else src="@/assets/banners/es/1564x726.png" >
        </div>

        <div v-if="i == 1" class="carousel_item_img">
          <img v-if="this.$i18n.locale == 'es'" src="@/assets/banners/es/1564x726px_v02.png" >
          <img v-else src="@/assets/banners/es/1564x726px_v02.png" >
          <div> 
            <a href="https://api.whatsapp.com/send?phone=5" target="_blank">
              <button class="button" >{{ $t("home.btnBanner2") }}</button>
            </a>
          </div>
        </div>
        
        <div v-if="i == 3" >
          <img v-if="this.$i18n.locale == 'es'" src="@/assets/banners/es/.png"  >
          <img v-else src="@/assets/banners/es/.png"   >
        </div>

        <div v-if="i == 2" >
          <img v-if="this.$i18n.locale == 'es'" src="@/assets/banners/es/1564x726px.png"  >
          <img v-else src="@/assets/banners/es/1564x726px.png"   >
          <div> 
            <a href="https://api.whatsapp.com/send?phone=52" target="_blank">
              <button class="button" >{{ $t("home.btnBanner2") }}</button>
            </a>
          </div>
        </div> 

        <div v-if="i == 3" >
          <img v-if="this.$i18n.locale == 'es'" src="@/assets/banners/es/1564x726px.png" >
          <img v-else src="@/assets/banners/es/.png" >
        </div> 

        <div v-if="i == 4" >
          <img v-if="this.$i18n.locale == 'es'" src="@/assets/banners/es/1564x726px.png"  >
          <img v-else src="@/assets/banners/es/_1564x726px.png"   >
        </div>  -->

      </v-carousel-item>
    </v-carousel> 
  </v-card>

  

</template>

<script>
export default {
  name: 'Home',
  components: {
  }, 
  data () {
      return {
        dialog: false,
      }
    },

}
</script>
<style scoped >
.button {
  width: 31.7rem;
  height: 6.7rem;
  font-size: 3.2rem;
}




</style>